import { render, staticRenderFns } from "./WasteSideBar.vue?vue&type=template&id=3bb96c26&"
import script from "./WasteSideBar.vue?vue&type=script&lang=js&"
export * from "./WasteSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports